import type { ReactNode } from "react";
import { SolfegeButtons } from "@music-app/ui-components";
import type { ExerciseRendererProps } from "./types.js";

export function SolfegeRenderer({
  exercise,
  pendingAnswer,
  gradingResult,
  disabled,
  onSubmit,
}: ExerciseRendererProps): ReactNode {
  const selectedId = pendingAnswer?.type === "option" ? pendingAnswer.optionId : undefined;
  const graded = gradingResult !== null;
  const buttons = exercise.options.map((opt) => ({
    syllable: opt.label,
    selected: selectedId === opt.id,
    correct: graded && exercise.correctAnswerId === opt.id,
    wrong: graded && selectedId === opt.id && exercise.correctAnswerId !== opt.id,
  }));
  return (
    <SolfegeButtons
      buttons={buttons}
      disabled={disabled}
      onSelect={(i) => {
        const opt = exercise.options[i];
        if (opt) onSubmit({ type: "option", optionId: opt.id });
      }}
    />
  );
}
